import { AuthorizationCatalogEntry } from '@/types';

/** Header-only sentinel. Never a catalog id, form value, or API parameter. */
export const ALL_BUSINESS_UNITS_ID = '__ALL__';

export const ALL_BUSINESS_UNITS_LABEL = 'All business units';

/**
 * Canonical catalog id for a stored bu, or null when blank or unknown.
 * Matches the id and its /identity aliases, case-insensitively. When aliases
 * are absent, only the id matches.
 */
export function resolveCanonicalBu(
  raw: string | null | undefined,
  catalog: AuthorizationCatalogEntry[] | null | undefined,
): string | null {
  const value = (raw ?? '').trim().toLowerCase();
  if (!value) {
    return null;
  }
  for (const entry of catalog ?? []) {
    if (entry.id.trim().toLowerCase() === value) {
      return entry.id;
    }
    const aliases = entry.aliases ?? [];
    if (aliases.some((alias) => alias.trim().toLowerCase() === value)) {
      return entry.id;
    }
  }
  return null;
}

/**
 * Display filter for a loaded row. All matches every row, including a blank
 * bu. Any other selection matches only a row whose bu resolves to that id.
 */
export function matchesSelectedBu(
  rowBu: string | null | undefined,
  selectedId: string | null | undefined,
  catalog: AuthorizationCatalogEntry[] | null | undefined,
): boolean {
  if (selectedId === ALL_BUSINESS_UNITS_ID) {
    return true;
  }
  const canonical = resolveCanonicalBu(rowBu, catalog);
  return canonical !== null && canonical === selectedId;
}
